(() => {
  if (window.ChusProductTiltInitialized) return;
  window.ChusProductTiltInitialized = true;

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function attachTilt(tile) {
    if (tile.dataset.ccTiltReady === 'true' || !finePointer.matches) return;
    tile.dataset.ccTiltReady = 'true';

    tile.addEventListener('pointermove', (event) => {
      const rect = tile.getBoundingClientRect();
      const x = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      const y = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
      const rotateX = (0.5 - y) * 9;
      const rotateY = (x - 0.5) * 11;

      tile.classList.add('is-tilting');
      tile.style.setProperty('--cc-shine-x', `${Math.round(x * 100)}%`);
      tile.style.setProperty('--cc-shine-y', `${Math.round(y * 100)}%`);
      tile.style.transform = `perspective(1050px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg)`;
    });

    tile.addEventListener('pointerleave', () => {
      tile.classList.remove('is-tilting');
      tile.style.transform = '';
      tile.style.removeProperty('--cc-shine-x');
      tile.style.removeProperty('--cc-shine-y');
    });
  }

  function initializeTilt(root = document) {
    root.querySelectorAll('[data-cc-product-tilt]').forEach(attachTilt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeTilt());
  } else {
    initializeTilt();
  }

  document.addEventListener('shopify:section:load', (event) => initializeTilt(event.target));
})();
